import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { MAX_BOM_WAREHOUSES, MAX_BOM_WAREHOUSES_MESSAGE } from './constraints.js';
export const bomWarehouseIdsSchema = z
    .array(requiredUuidString('Warehouse is required.', 'Invalid warehouse selection.'))
    .max(MAX_BOM_WAREHOUSES, MAX_BOM_WAREHOUSES_MESSAGE)
    .refine((ids) => new Set(ids).size === ids.length, 'Choose each warehouse only once.');
//# sourceMappingURL=bom-warehouse-ids-schema.js.map